import {
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import Map from 'components/Map';
import Row from 'components/Row';
import Skeleton from 'components/Skeleton';
import { AddressContext } from 'constants/contexts';
import React, {
  useContext,
} from 'react';

function AddressForm({ loading }) {
  const { editingAddress, setEditingAddress } = useContext(AddressContext);
  function handleUpdateAddress(payload) {
    setEditingAddress((adr) => ({ ...adr, ...payload }));
  }

  return (
    <form>
      <div style={{
        position: 'relative',
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
      >
        <Map
          center={editingAddress}
          height={150}
          zoomControl={false}
          fullscreenControl={false}
        >
          <Map.FixedMarker />
        </Map>
        <Box sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          px: 2,
          py: 1,
          backgroundColor: 'background.80',

        }}
        >
          <Typography variant="body-caption">
            {editingAddress.text}
          </Typography>
        </Box>
      </div>

      <Stack spacing={2} my={4}>
        <TextField
          value={editingAddress.label}
          disabled={loading}
          label="Label"
          variant="outlined"
          size="small"
          onChange={({ target: { value } }) => handleUpdateAddress({ label: value })}
          data-testid="address-label"
        />
        <TextField
          value={editingAddress.details}
          disabled={loading}
          label="Apartment, suite or floor"
          variant="outlined"
          size="small"
          onChange={({ target: { value } }) => handleUpdateAddress({ details: value })}
          data-testid="address-details"
        />
        <TextField
          label="Instructions for delivery"
          disabled={loading}
          value={editingAddress.deliveryInstructions}
          variant="outlined"
          size="small"
          multiline
          rows={3}
          onChange={({ target: { value } }) => handleUpdateAddress({ deliveryInstructions: value })}
          data-testid="address-delivery-instructions"
        />
      </Stack>
    </form>
  );
}

function AddressFormSkeleton() {
  return (
    <Skeleton>
      <AddressForm loading />
    </Skeleton>
  );
}
export default Skeleton.withSkeleton(AddressForm, AddressFormSkeleton);
